import { RootState } from "..";

export const getPredictionRunningState = (state: RootState) =>
  state.PredictionReducer.predictionRunningState;

export const getPredictionSubmitState = (state: RootState) =>
  state.PredictionReducer.predictionSubmitState;

export const getCurrentPredictionStep = (state: RootState) =>
  state.PredictionReducer.predictionStep;

export const getPredictionData = (state: RootState) =>
  state.PredictionReducer.predictionData;
